import React from 'react';
import classNames from 'classnames';
import { Tooltip, TooltipPosition } from '../Tooltip';
import classes from './TableTooltip.module.scss';

interface IProps {
    tooltipText: string;
    className?: string;
    position?: TooltipPosition;
}

export const TableTooltip: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <div className={classes.container} role="button" tabIndex={0}>
        <Tooltip
            className={classNames(classes.tooltip, props.className)}
            position={props.position}
            isSmall
        >
            {props.tooltipText}
        </Tooltip>
        {props.children}
    </div>
);
